(function() {
  'use strict';

  // Offline-only license gate (lifetime/local). No network calls, no CDN.
  var CONFIG = {
    DEBUG: false
  };

  function log() {
    if (CONFIG.DEBUG && typeof console !== 'undefined') {
      try { console.log.apply(console, ['[Untamed Offline License]'].concat([].slice.call(arguments))); } catch (_) {}
    }
  }

  function base64UrlDecode(str) {
    try {
      return JSON.parse(atob(str.replace(/-/g, '+').replace(/_/g, '/')));
    } catch (_) { return null; }
  }

  function verifyLifetimeLicense(licenseKey) {
    try {
      if (!licenseKey || typeof licenseKey !== 'string') return { valid: false, reason: 'missing' };
      var parts = licenseKey.split('.');
      if (parts.length !== 3) return { valid: false, reason: 'format' };
      var header = base64UrlDecode(parts[0]);
      var payload = base64UrlDecode(parts[1]);
      if (!header || !payload) return { valid: false, reason: 'decode' };
      // Offline heuristic: require type === 'lifetime'. We do NOT verify signature.
      if (payload.type !== 'lifetime') return { valid: false, reason: 'type' };
      // Optional: if exp exists and is in the past, treat invalid (should not be set for lifetime)
      if (typeof payload.exp === 'number' && Math.floor(Date.now() / 1000) > payload.exp) {
        return { valid: false, reason: 'expired' };
      }
      return { valid: true, payload: payload };
    } catch (e) {
      return { valid: false, reason: 'error' };
    }
  }

  function showOverlay(message) {
    try {
      var overlay = document.createElement('div');
      overlay.setAttribute('style', 'position:fixed;inset:0;background:rgba(255,255,255,.98);z-index:2147483647;display:flex;align-items:center;justify-content:center;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Arial,sans-serif;');
      overlay.innerHTML = '<div style="text-align:center;padding:40px;max-width:560px">\
        <div style="font-size:48px;color:#ff4444;margin-bottom:16px">⚠️</div>\
        <h2 style="margin:0 0 10px 0;color:#333">' + (message || 'License required') + '</h2>\
        <p style="margin:0;color:#666">Please configure your Untamed theme license key in theme settings.</p>\
      </div>';
      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';
    } catch (_) {}
  }

  function enableTheme() {
    // No-op: With offline mode, everything is enabled by default.
    log('Theme enabled (offline license mode)');
  }

  function init() {
    if (!window.UntamedThemeSettings) {
      // try again shortly if settings not ready
      setTimeout(init, 100);
      return;
    }
    var key = window.UntamedThemeSettings.licenseKey;
    if (!key || String(key).trim() === '') {
      document.addEventListener('DOMContentLoaded', function() { showOverlay('Theme License Required'); });
      return;
    }
    var result = verifyLifetimeLicense(String(key));
    if (!result.valid) {
      document.addEventListener('DOMContentLoaded', function() { showOverlay('Invalid or non-lifetime license'); });
      return;
    }
    // Valid lifetime -> enable, nothing else to do
    enableTheme();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


